/**
 * 自有账户 API — GET /api/owned-accounts（外部平台自有账户，资源池）。
 *
 * 二期批3（PRD §4.6.2 R3）：
 * - 列表新增 product_id 参数：选中产品时返回「全公司共享 + 专属此产品」并集；
 * - 新增 patchOwnedAccount（Web 端唯一资源专属写入口）：设置/解除产品专属。
 */
import client from "./client";
import type { PlatformAccountItem } from "../types";

/** 自有账户查询参数。 */
export interface OwnedAccountParams {
  level?: string;
  company_id?: string;
  brand_id?: string;
  /** R3：选择器产品过滤——返回共享（product_id IS NULL）+ 专属此产品的并集。 */
  product_id?: string;
}

/** 获取自有账户列表。 */
export async function getOwnedAccounts(
  params?: OwnedAccountParams,
): Promise<PlatformAccountItem[]> {
  return client.get<unknown, PlatformAccountItem[]>("/owned-accounts", {
    params,
  });
}

/**
 * 设置/解除产品专属（PRD §4.6.2 R3）。
 * PATCH /api/owned-accounts/{id}，body { product_id }；
 * productId 传 null 表示解除专属、恢复全公司共享。
 * 后端校验：记录须在租户可见范围（40400）；产品存在、同租户、同资产树（42200）。
 */
export async function patchOwnedAccount(
  recordId: string,
  productId: string | null,
): Promise<PlatformAccountItem> {
  return client.patch<unknown, PlatformAccountItem>(
    `/owned-accounts/${recordId}`,
    { product_id: productId },
  );
}
